import { credentialsRepository } from 'data/repositories/credential.repository';

export const startAppcues = () => {
    const credentials = credentialsRepository.getCredentials();
    if (credentials && window.Appcues) {
        const { id, firstName, role: accountStatus, cblc: accountCblc } = credentials.user;
        window.Appcues.page();
        window.Appcues.identify(id, { id, firstName, accountCblc, accountStatus });
    }
};
